define([
	"dojo/_base/declare",
	"csi/def",
	"csi/form/Widget",
	"csi/locale",
	"csi/prefs",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Search",
	"./SelectSetHelper"
], function(declare, def, Widget, locale, prefs, Names, xml, Search, SelectSetHelper) {

	var _SUBTYPE = "Subtype";
	var _DP_TEMPLATE = "DPTemplate";
	var _PDF_VIEW = "PDFView";

	var WIZARD_NAME_SELECT_SET_TYPE_DEF = {
		"ApparelBOMSelectSetWizard": "ApparelBOM",
		"ColorwaySelectSetWizard": "Colorway",
		"SKUSelectSetWizard": "SKU",
		"SKUMaterialSelectSetWizard": "SKUMaterial",
		"StyleSelectSetWizard": "Style",
		"SupplierItemSelectSetWizard": "StyleSupplierItem",
		"ThemeSelectSetWizard": "Theme"
	};

	return declare(Widget, {

		/** @property {String} - Subtype value */
		subType: null,

		_resolveSelectSetType: function() {
			var ctx = this.getContext();
			var wizardName = ctx.view && ctx.view.viewParent ? ctx.view.viewParent.defView.m_name : null;
			if (wizardName) {
				return WIZARD_NAME_SELECT_SET_TYPE_DEF[wizardName];
			}
			var source = this.defView.getSource();
			return source && source.m_urlParent ? SelectSetHelper.resolveSelectSetType(source.m_urlParent) : null;
		},

		_resolveView: function() {
			this._type = this._resolveSelectSetType();
			if (this._type != SelectSetHelper.SITE_LEVEL_VIEW_NODE_TYPE) {
				var subTypeValue = SelectSetHelper.SUBTYPE_URL_PREFIX + this._type;
				this.addDefaultValue(_SUBTYPE, subTypeValue);
				this.subType = subTypeValue;
			}
			this.inherited(arguments);
		},

		isFieldEditable: function(/*Field*/field) {
			if (field.m_id == _SUBTYPE) {
				//make the type field not editable if it is set in _buildView
				if (this._type != SelectSetHelper.SITE_LEVEL_VIEW_NODE_TYPE) {
					return false;
				}
			}
			return this.inherited(arguments);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			//summary: return __Print__ view of the appropriate object depending on the Subtype attribute
			//similar to CustomViewRenderer
			var name = field.getControlName();
			if (name == "PDFView") {
				var type = SelectSetHelper.getPdfTypeFromURL(this.defView.getFieldValue(_SUBTYPE));
				var keyView = def.composeViewKey("__Print__", type);
				field.m_relationship = prefs.getStoreRelationship(keyView);
				//this._bHideView = !keyView;
			}

			if (name == "Subtype") {
				// TODO: replace with csi/config#getSubtypeStore when select set subtypes are cached correctly
				var s = new Search();
				s.byType("SelectSetSubtype");
				s.getQuery().Attr("Active", xml.OP_EQUALS, true, xml.path("Settings"));

				return new Names({
					request: s.getRequest(),
					typeNode: "SelectSetSubtype",
					onResultItem: function(item) {
						item.Name = locale.resourceIfExists("SelectSetSubtype_" + item.Name) || locale.type(item.Name) || "";
					}
				});
			}

			if (name == _DP_TEMPLATE) {
				var type = SelectSetHelper.getNameFromURL(this.defView.getFieldValue(_SUBTYPE)) || this._type;

				var s = new Search();
				s.byType("DataPackageTemplate");
				s.getQuery().Attr("Active", xml.OP_EQUALS, true)
					.Attr("IsSupplierSpecific", xml.OP_EQUALS, false)
					.Attr("TemplateType", xml.OP_EQUALS, "DataPackageContainerType:" + type);

				return new Names({
					request: s.getRequest(),
					typeNode: "DataPackageTemplate"
				});
			}

			return this.inherited(arguments);
		},

		/** 
		* @override
		* Validate Subtype in form with other details
		*/
		validateForm(errorParams) {
			if (!this.getFieldValue("Subtype")) {
				throw new Error(locale.resource("EmptySubtypeInSelectSetError"));
			}
			return this.inherited(arguments);
		},

		_updateFieldVisibility: function(/*Field?*/field) {
			// summary: set visibility of fields
			var b = this.inherited(arguments);

			if (!field || (field.m_id == _SUBTYPE)) {
				var type = SelectSetHelper.getNameFromURL(this.defView.getFieldValue(_SUBTYPE)) || this._type;
				var bProduct = (type == "Style" || type == "Material");
				this.setFieldHidden(_DP_TEMPLATE, !type || !bProduct);
				this.setFieldHidden(_PDF_VIEW, !type || bProduct);
				return true;
			}

			return b;
		}
	});
});
